export default __webpack_public_path__ + "static/media/pic1.23eb9988.jpg";